import { Link, useNavigate } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import config from "../../config/config";
import moment from "moment";
import Loader from "../Loader/Loader";
import CurrencySymbols from "../../common/CurrencySymbol";
import { AppContext } from "../../context/AppContext";
const RecentTransactionsModal = ({ id, transactionType, callBackData }) => {
  const [recentData, setRecentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem("Token");
  const location = localStorage.getItem("Location");
  const LoginId = localStorage.getItem("ID");
  const { CurrencySymbol, FractionDigits, dateFormate } =
    useContext(AppContext);

  console.log(recentData, "recentData");

  useEffect(() => {
    if (id > 0) {
      setLoading(true);
      axios
        .get(
          `${config.accountingBaseUrl}/chartofaccounts/recenttransactionsbytransactiontype?transactionType=${transactionType}&locationId=${location}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log(res.data.ResponseData, "recenttransactions");
          setRecentData(res.data.ResponseData);
          if (res.data.ResponseData?.length > 0) {
            callBackData(res.data.ResponseData[0]);
          }

          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  }, [id]);

  return (
    <>
      <Loader loading={loading} />
      <div
        className="modal fade top-right-modal"
        id="RecentTransactionsModal"
        tabIndex={-1}
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content" style={{ minHeight: "500px" }}>
            <div className="modal-header">
              <p className="modal-title p-lg">
                Recent{" "}
                {transactionType === "Journal Entry"
                  ? "Journal Entrie"
                  : transactionType}
                s
              </p>

              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="table-responsive">
                    <table className="table">
                      <tbody>
                        {recentData.length > 0 ? (
                          recentData.map((item, index) => (
                            <tr
                              key={index}
                              data-bs-dismiss="modal"
                              aria-label="Close"
                              style={{ cursor: "pointer", color: "blue" }}
                              onClick={() => {
                                navigate(
                                  transactionType === "Bank Deposit"
                                    ? `/bank-deposit/${item?.ID}`
                                    : transactionType === "Transfer"
                                    ? `/manage-transfer/${item?.ID}`
                                    : transactionType === "Journal Entry"
                                    ? `/journal-entry/${item?.ID}`
                                    : transactionType === "Receive Payment"
                                    ? `/receive-payment/${item?.ID}`
                                    : transactionType === "Expense"
                                    ? `/Expense/${item?.ID}`
                                    : `/receiving-paybills/${item?.ID}`
                                );
                                // window.location.reload();
                              }}
                            >
                              <td>{item.Type}</td>
                              <td className="word-break-data">
                                {moment(item?.Date).format(
                                  dateFormate.toUpperCase()
                                )}
                                {/* {moment(item?.Date).format("MM-DD-YYYY")} */}
                              </td>
                              <td className="word-break-data">{item.Memo}</td>
                              {item?.AccountName && (
                                <td className="word-break-data">
                                  {item.AccountName}
                                </td>
                              )}
                              <td style={{ textAlign: "left" }}>
                                {CurrencySymbols(
                                  Number(item?.Amount),
                                  { CurrencySymbol },
                                  FractionDigits
                                )}
                              </td>
                              {item?.Contact && (
                                <td className="word-break-data">
                                  {item?.Contact}
                                </td>
                              )}
                            </tr>
                          ))
                        ) : (
                          <tr style={{ textAlign: "center", columnSpan: 6 }}>
                            <td>No Data</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    <div
                      className="bold"
                      style={{
                        textAlign: "center",
                        borderTop: "1px solid black",
                        paddingTop: "5px",
                      }}
                    >
                      <span
                        className="cursor-pointer"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={() => navigate(`/transaction-log?ttid=${id}`)}
                      >
                        Show More
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RecentTransactionsModal;
